import React from 'react'
import '../../styles/Diagnostic/DiagnosticERP.css'
import { Fade } from 'react-awesome-reveal'
import { Accordion, Col, Row } from 'react-bootstrap'
import AccordionText from '../Utils/AccordionText'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'

function DiagnosticERP() {

    const section2Accordion1Data = [
        {
            title: "Expertise et fiabilité",
            text: "Notre équipe d’experts certifiés réalise un diagnostic précis et conforme aux dernières mises à jour des informations préfectorales."
        }, {
            title: "Conseil personnalisé",
            text: "Nous vous accompagnons dans la compréhension des résultats de l’ERP et dans les éventuelles démarches à suivre pour réduire les risques identifiés."
        }, {
            title: "Rapidité et efficacité ",
            text: "Notre processus optimisé garantit une réalisation rapide de l’ERP, vous permettant de poursuivre votre transaction immobilière sans délai."
        }
    ]

    const section2Accordion2Data = [
        {
            title: "Identification de la zone",
            text: "Vérification si le bien est situé dans une zone à risque à l’aide des données préfectorales et municipales."
        }, {
            title: "Collecte des informations",
            text: "Rassemblement des informations nécessaires concernant les différents risques et pollutions."
        }, {
            title: "Rédaction de l'ERP",
            text: "Compilation des données recueillies dans un rapport clair et détaillé, facile à comprendre pour le non-spécialiste."
        }, {
            title: "Explication des résultats",
            text: "Nous vous fournissons une explication détaillée des résultats et des recommandations pratiques."
        }
    ]

    const section4Accordion1Data = [
        {
            title: "Sécurité et transparence pour l'acheteur",
            text: "L’ERP joue un rôle crucial dans le processus de vente en informant l’acquéreur sur les risques liés au bien est exposé. Cette information préalable permet à l’acheteur de prendre sa décision en toute connaissance de cause, contribuant ainsi à une transaction transparente et sécurisée."
        }, {
            title: "Obligation légale pour le vendeur",
            text: "La loi impose la fourniture de l’ERP dans le dossier de diagnostic technique (DDT) remis à l’acheteur au moment de la vente. Le non-respect de cette obligation peut entraîner l’annulation de la vente ou une diminution du prix de vente si des risques non déclarés sont découverts postérieurement."
        }
    ]

    const section4Accordion2Data = [
        {
            title: "Protection et information du locataire",
            text: "L’ERP assure que le locataire est pleinement informé des risques liés au bien est exposé. Cette transparence renforce la confiance entre le locataire et le bailleur, et garantit une relation locative sereine."
        }, {
            title: "Obligation légale pour le bailleur ",
            text: "Fournir un ERP actualisé est une obligation légale pour le bailleur lors de la signature ou du renouvellement du bail. L’omission ou la fourniture d’un document non conforme peut entraîner des conséquences juridiques défavorables pour le bailleur."
        }
    ]

    return (

        <>
            <Helmet>
                <meta name="title" content="Diagnostic État des Risques et Pollutions (ERP) - E5M Diagnostics" />
                <meta name="description" content="Diagnostic État des Risques et Pollutions (ERP) sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:title" content="Diagnostic État des Risques et Pollutions (ERP) - E5M Diagnostics" />
                <meta property="og:description" content="Diagnostic État des Risques et Pollutions (ERP) sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr/diagnostic-ERP" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr/diagnostic-ERP" />
            </Helmet>

            <BrowserView>
                <div id='diagnosticERP'>
                    <div id='header'>
                        <div id='diagnosticERPHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilter'>
                                    <h1 id='headerFilterTitle'>État des Risques et Pollutions (ERP)</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <Row id='diagnosticERPSection1'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticERPSection1Left'>
                                    <h1 className='sectionTitle'>État des Risques et Pollutions : êtes-vous concerné ?</h1>
                                    <div className='sectionText'>
                                        L’État des Risques et Pollutions est un document qui informe l’acheteur ou le locataire sur les risques naturels, miniers, technologiques, ainsi que sur la pollution des sols auxquels le bien immobilier est exposé. Ce document
                                        est obligatoire pour toute vente ou location de biens immobiliers situés dans des zones couvertes par un plan de prévention des risques (naturels, miniers, technologiques) ou dans des zones à potentiel radon significatif et des
                                        secteurs d’information sur les sols.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='diagnosticERPSection1Right'>
                                    <h1 className='sectionTitle'>Objectifs de l'ERP</h1>
                                    <div className='sectionText'>
                                        L’ERP a pour objectifs principaux de :
                                    </div>
                                    <ul>
                                        <li>Informer l’acheteur ou le locataire sur les risques et pollutions associés au bien est exposé.</li>
                                        <li>Prévenir les dommages et garantir la sécurité des personnes en permettant l’adoption de mesures de précaution adéquates.</li>
                                        <li>Contribuer à la gestion durable des territoires en sensibilisant les propriétaires et occupants à ces risques.</li>
                                    </ul>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='diagnosticERPSection2'>
                        <Col>
                            <Fade direction={'right'} duration={500}>
                                <div id='diagnosticERPSection2Left'>
                                    <h1 className='sectionTitle'>Avantages de notre Diagnostic ERP</h1>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section2Accordion1Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'right'} duration={500}>
                                <div id='diagnosticERPSection2Right'>
                                    <h1 className='sectionTitle'>Méthodologie</h1>
                                    <div className='sectionText'>
                                        Notre méthodologie pour la réalisation de l’ERP comprend :
                                    </div>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section2Accordion2Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='diagnosticERPSection3'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitle'>Réglementation</h1>
                            <div className='sectionText'>
                                L’obligation de fournir un ERP est encadrée par le Code de l’environnement et la loi ALUR (Accès au Logement et un Urbanisme Rénové). Tout propriétaire désireux de vendre ou de louer son bien doit fournir ce document à l’acheteur ou au
                                locataire. L’ERP doit être réalisé moins de six mois avant la conclusion de la transaction pour garantir la validité des informations fournies.
                            </div>
                        </Fade>
                    </div>
                    <Row id='diagnosticERPSection4'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticERPSection4Left'>
                                    <h1 className='sectionTitle'>L'ERP pour la vente : Une obligation pour informer et protéger</h1>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section4Accordion1Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticERPSection4Right'>
                                    <h1 className='sectionTitle'>ERP pour la location : Transparence et sécurité</h1>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section4Accordion2Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                </div>
            </BrowserView>

            <MobileView>
                <div id='diagnosticERP'>
                    <div id='header'>
                        <div id='diagnosticERPHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilterMobile'>
                                    <h1 id='headerFilterTitleMobile'>État des Risques et Pollutions (ERP)</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='diagnosticERPSection1Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>État des Risques et Pollutions : êtes-vous concerné ?</h1>
                            <div className='sectionTextMobile'>
                                L’État des Risques et Pollutions est un document qui informe l’acheteur ou le locataire sur les risques naturels, miniers, technologiques, ainsi que sur la pollution des sols auxquels le bien immobilier est exposé. Ce document
                                est obligatoire pour toute vente ou location de biens immobiliers situés dans des zones couvertes par un plan de prévention des risques (naturels, miniers, technologiques) ou dans des zones à potentiel radon significatif et des
                                secteurs d’information sur les sols.
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <h1 className='sectionTitleMobile'>Objectifs de l'ERP</h1>
                            <div className='sectionTextMobile'>
                                L’ERP a pour objectifs principaux de :
                            </div>
                            <div className='sectionTextMobile'>
                                <ul>
                                    <li>Informer l’acheteur ou le locataire sur les risques et pollutions associés au bien est exposé.</li>
                                    <li>Prévenir les dommages et garantir la sécurité des personnes en permettant l’adoption de mesures de précaution adéquates.</li>
                                    <li>Contribuer à la gestion durable des territoires en sensibilisant les propriétaires et occupants à ces risques.</li>
                                </ul>
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticERPSection2Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Avantages de notre Diagnostic ERP</h1>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section2Accordion1Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Méthodologie</h1>
                            <div className='sectionTextMobile'>
                                Notre méthodologie pour la réalisation de l’ERP comprend :
                            </div>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section2Accordion2Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticERPSection3Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Réglementation</h1>
                            <div className='sectionTextMobile'>
                                L’obligation de fournir un ERP est encadrée par le Code de l’environnement et la loi ALUR (Accès au Logement et un Urbanisme Rénové). Tout propriétaire désireux de vendre ou de louer son bien doit fournir ce document à l’acheteur ou au
                                locataire. L’ERP doit être réalisé moins de six mois avant la conclusion de la transaction pour garantir la validité des informations fournies.
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticERPSection4Mobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>L'ERP pour la vente : Une obligation pour informer et protéger</h1>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section4Accordion1Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>ERP pour la location : Transparence et sécurité</h1>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section4Accordion2Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                </div>
            </MobileView>
        </>

    )

}

export default DiagnosticERP